var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { toString } from 'lodash';
import { classNames } from '@shapeable/utils';
var cls = classNames('outline-entity-number');
export var defaultOutlineEntityNumberFontSizes = {
  '1': 38 / 13,
  '2': 28 / 13,
  '3': 21 / 13,
  '4': 18 / 13,
  '5': 13 / 13
};
export var OutlineEntityNumberDefaultProps = {
  sizes: defaultOutlineEntityNumberFontSizes,
  useEntityColorForText: true,
  tag: 'h2',
  colors: {
    text: 'strong'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 500;\n    font-size: ", ";\n    ", ";\n  "], ["\n    margin: 0;\n    font-weight: 500;\n    font-size: ", ";\n    ", ";\n  "])), theme.FONT_SIZE(13), theme.APPLY_COLORS)
});
var NumberStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var ems = _a.ems;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      line-height: 1em;\n      font-size: ", "em;\n    "], ["\n      line-height: 1em;\n      font-size: ", "em;\n    "])), ems);
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Number: styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), NumberStyles)
};
export var OutlineEntityNumber = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    tag = props.tag,
    sizes = props.sizes;
  var colors = props.useEntityColorForText ? {
    text: entity.color.value
  } : props.colors;
  // determine the level of the outline number by splitting on periods - i.e. 4 is 1, 4.1 is 2, 4.1.1 is 3, etc.
  var level = toString((entity.outlineNumber || '').split('.').length || 1);
  var ems = sizes[level] || 1;
  return (
    // @ts-ignore - tag as a string is fine?
    React.createElement(My.Container, {
      colors: colors,
      ems: ems,
      as: tag,
      ems: ems,
      className: cls.name(className)
    }, React.createElement(My.Number, {
      ems: ems
    }, entity.outlineNumber))
  );
};
OutlineEntityNumber.defaultProps = OutlineEntityNumberDefaultProps;
OutlineEntityNumber.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;